<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br />
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">As On</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled" />
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="toDate"
              v-model="toDate" />
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button @click.prevent="customerReceivableReport" class="p-button p-component addNewBtn btn-btm-0"
              label="Search" icon="pi pi-search" />
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button @click.prevent="reset" v-if="this.customerReceivableList.length > 0" class="p-button-raised"
              icon="pi pi-refresh" label="Reset" />
          </div>
        </div>
        <div class="p-grid p-col-12">
          <Button class="p-button-raised" @click.prevent="exportToPdf()" icon="pi pi-print" />
        </div>
      </form>

      <DataTable :value="customerReceivableList" :paginator="true" :rows="100" :rowsPerPageOptions="[100, 500, 1000]"
        class="p-datatable-responsive p-datatable-customers" :filters="filters">

        <Column :sortable="true" header="Name" field="name" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['name']" />
          </template>
          <template #footer>
           Total:
          </template>
        </Column>
        <Column :sortable="true" header="Contact Number" field="primaryContactNumber" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['primaryContactNumber']" />
          </template>
        </Column>
        <!-- <column  header="Contact Number" :sortable="true" field="primaryContactNumber"></column> -->
        <!-- <column  header="Address" field="address"></column> -->
        <Column :sortable="true" header="Address" field="address" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['address']" />
          </template>
        </Column>
        <Column :sortable="true" header="Closing Balance" field="closingBalance" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['closingBalance']" />
          </template>
          <!-- <Column :footer="totalBalance" /> -->
          <template #footer>
            {{total.toFixed(4)}}
          </template>
          
        </Column>

        <!-- <column  header="Closing Balance"  bodyStyle="text-align: right"  :sortable="true" field="closingBalance"></column> -->
        <!-- <column  header="Dr-Cr"  bodyStyle="text-align: left" :sortable="true" field=drCr></column> -->
        <Column :sortable="true" header="Dr-Cr" field="drCr" filterMatchMode="contains">
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['drCr']" />
          </template>
        </Column>
        <template #empty>No record found</template>
      </DataTable>
    </div>
  </section>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DatePicker from 'vue2-datepicker'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
export default {
  name: 'customerReceivableReport',
  data() {
    return {
      toDate: null,
      customerReceivableList: [],
      filters: {},
      loading: false,
      englishDateEnabled: true,
      columnList: '',
      total: 0
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  computed: {
  },
  methods: {
    async customerReceivableReport() {
      this.loading = true
      let response = await this.$store.dispatch('customerOutstandingReport', this.toDate)
      this.customerReceivableList = response.data.data
      this.loading = false
      this.totalBalance()
    },
    totalBalance() {
      this.total = 0.0
      for (let sale of this.customerReceivableList) {
        this.total += sale.closingBalance
      }
      return this.total
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    reset() {
      this.customerReceivableList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    exportToPdf() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      axios({
        url: globalKey + '/fileDownload/printFinalReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + this.$store.getters.fyId + '/' + data.toDate + '/' + data.toDate + '/Profit And Loss',
        method: 'get',
        headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), { type: response.data.type })
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'profitAndLoss.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    setEnglishDate() {
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    }
  },
  components: {
    DataTable,
    Column,
    DatePicker,
    InputMask,
    Button,
    InputText
  }
}
</script>
<style  scoped src="@../../../static/css/purchase.css"></style>



// WEBPACK FOOTER //
// customerReceivableReport.vue?5fd66ffc